/* eslint-disable react/jsx-no-target-blank */
import React, { Component } from "react";
import PropTypes from "prop-types";
import InputRow from "./InputRow";
import Loading from "./Loading";

export default class TestScores extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tests: [],
      testData: [],
      testTypeData: [],
      loading: true,
      dateTakenError: "",
    };
    this.updateDateTaken = this.updateDateTaken.bind(this);
    this.deleteDateTaken = this.deleteDateTaken.bind(this);
    this.updateScore = this.updateScore.bind(this);
    this.updateTest = this.updateTest.bind(this);
    this.updateTestType = this.updateTestType.bind(this);
    this.deleteTest = this.deleteTest.bind(this);
    this.addTest = this.addTest.bind(this);
    this.getTestTypeData = this.getTestTypeData.bind(this);
  }

  componentDidMount() {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/AcademicTest/GetAcademicTestCodes`
    )
      .then((res) => res.json())
      .then(async (res) => {
        if (res.length) {
          this.setState({ testData: res });
        }
      })
      .then(() => {
        if (
          this.props.testScore.tests &&
          this.props.testScore.tests.length > 0
        ) {
          this.props.testScore.tests.forEach((element, i) => {
            let dateTaken = "";
            if (element.dateTaken) {
              const date = new Date(element.dateTaken);
              let month = date.getMonth() + 1;
              let day = date.getDate();
              let year = date.getFullYear();
              if (month < 10) {
                month = "0" + month;
              }
              if (day < 10) {
                day = "0" + day;
              }
              if (year < 10) {
                year = "000" + year;
              } else if (year < 100) {
                year = "00" + year;
              } else if (year < 1000) {
                year = "0" + year;
              }
              dateTaken = year + "-" + month + "-" + day;
              element.dateTaken = dateTaken;
            }
          });
        }
        this.setState({
          tests:
            this.props.testScore.tests && this.props.testScore.tests.length > 0
              ? this.props.testScore.tests
              : [
                  {
                    test: "",
                    testType: "",
                    score: "",
                    dateTaken: "",
                  },
                ],
        });
      })
      .catch((err) => console.log(err));

    if (this.props.testScore.tests && this.props.testScore.tests.length > 0) {
      this.props.testScore.tests.forEach(async (element, i) => {
        const data = await this.getTestTypeData(element.test, i);
        if (data === 1 && i + 1 === this.props.testScore.tests.length) {
          this.setState({ loading: false });
        }
      });
    } else {
      this.setState({ loading: false });
    }
  }

  async getTestTypeData(value, index) {
    return fetch(
      `${process.env.REACT_APP_API_URL}/api/AcademicTest/GetTestTypeByTest?TestId=${value}`
    )
      .then((res) => res.json())
      .then((res) => {
        const testTypeData = Array.from(this.state.testTypeData);
        testTypeData[index] = JSON.stringify(res);
        this.setState({ testTypeData: testTypeData });
        if (Array.isArray(res) && res.length === 1) {
          const tests = [...this.state.tests];
          const newTests = [...tests];
          newTests[index].testType = res[0].Id;

          this.setState({ tests: newTests });
          this.props.collectState("TS", { tests: newTests });
        }
        return 1;
      });
  }

  updateTest(value, index) {
    this.getTestTypeData(value, index).catch((err) => console.log(err));
    const { tests } = this.state;
    const newTest = Array.from(tests);
    tests.forEach((element, i) => {
      if (i === index) {
        element.test = value;
        element.testType = "";
        element.dateTaken = "";
        element.score = "";
      }
    });
    this.props.collectState("TS", {
      tests: newTest,
    });
    this.setState({ tests: newTest });
  }

  updateTestType(value, index) {
    const { tests } = this.state;
    const newTest = Array.from(tests);
    tests.forEach((element, i) => {
      if (i === index) {
        element.testType = value;
      }
    });

    this.props.collectState("TS", {
      tests: newTest,
    });
    this.setState({ tests: newTest });
  }

  updateScore(value, index) {
    const { tests } = this.state;
    const newTest = Array.from(tests);
    tests.forEach((element, i) => {
      if (i === index) {
        element.score = value;
      }
    });
    this.props.collectState("TS", {
      tests: newTest,
    });
    this.setState({ tests: newTest });
  }

  updateDateTaken(value, index, dateTakenError) {
    const { tests } = this.state;
    const newTest = Array.from(tests);
    const dateTaken = new Date(value);
    const isESLSCA = tests[index].test === "18" || tests[index].test === 18; // Assuming "2" is the id for TOEFL

    tests.forEach((element, i) => {
      if (i === index) {
        // Allow future dates only if the test is TOEFL
        if (isESLSCA && dateTaken >= new Date()) {
          element.dateTaken = value;
          dateTakenError = "";
        } else if (isESLSCA && dateTaken <= new Date()) {
          element.dateTaken = "";
          dateTakenError = "Date cannot be in the past if the test is ESLSCA.";
        } else if (dateTaken <= new Date() && !isESLSCA) {
          element.dateTaken = value;
          dateTakenError = "";
        } else {
          element.dateTaken = "";
          dateTakenError = "Date taken cannot be in the future.";
        }
        this.setState({ dateTakenError: dateTakenError });
      }
    });

    this.props.collectState("TS", {
      tests: newTest,
    });
    this.setState({ tests: newTest });
  }

  deleteDateTaken(value, index) {
    const { tests } = this.state;
    const newTest = Array.from(tests);
    tests.forEach((element, i) => {
      if (i === index) {
        element.dateTaken = "";
      }
    });
    this.props.collectState("TS", {
      tests: newTest,
    });
    this.setState({ tests: newTest });
  }

  deleteTest(index) {
    const { tests } = this.state;
    const newTest = [];
    tests.forEach((element, i) => {
      if (i !== index) {
        newTest.push(element);
      }
    });
    this.props.collectState("TS", {
      tests: newTest,
    });
    this.setState({ tests: newTest });
  }

  addTest() {
    const { tests } = this.state;
    if (tests.length >= 5) {
      alert("Only 5 test types can be added!");
      return;
    }
    let count = 1;
    const errorCheck = ["", 0, null, undefined];
    tests.forEach((element) => {
      if (
        errorCheck.indexOf(element.test) !== -1 ||
        errorCheck.indexOf(element.testType) !== -1 ||
        errorCheck.indexOf(element.dateTaken) !== -1 ||
        errorCheck.indexOf(element.score) !== -1
      ) {
        count = 0;
      }
    });
    if (count === 1) {
      this.setState({
        tests: [
          ...this.state.tests,
          {
            test: "",
            testType: "",
            score: "",
            dateTaken: "",
          },
        ],
      });
      this.props.collectState("TS", {
        tests: [
          ...this.state.tests,
          {
            test: "",
            testType: "",
            score: "",
            dateTaken: "",
          },
        ],
      });
    } else {
      alert(
        "Please fill all the fields of all the rows before adding new rows"
      );
    }
  }

  render() {
    const validationError = this.props.error;
    const { tests, testData, testTypeData, loading, dateTakenError } =
      this.state;
    if (loading) {
      return <Loading />;
    }
    const testView = [];
    tests.forEach((element, index) => {
      testView.push(
        <div
          className="english-profi"
          style={{ display: "flex", flexDirection: "row" }}
        >
          <InputRow
            value={element.test}
            data={testData}
            errMsg={
              validationError.length > 0 && validationError[index].test
                ? validationError[index].test
                : ""
            }
            name="select"
            rowName="Test"
            onChange={async (val) => {
              await this.updateTest(val, index);
            }}
          />
          <InputRow
            value={element.testType}
            data={element.test ? JSON.parse(testTypeData[index] || "[]") : []}
            name="select"
            required={element.test !== "" ? "*" : ""}
            errMsg={
              validationError.length > 0 && validationError[index].testType
                ? validationError[index].testType
                : ""
            }
            rowName="Type"
            onChange={(val) => {
              this.updateTestType(val, index);
            }}
          />
          <InputRow
            value={element.score}
            name="text"
            required={
              element.test !== "" &&
              element.test !== 18 &&
              element.test !== "18"
                ? "*"
                : ""
            }
            disabled={element.test === "18" || element.test === 18}
            errMsg={
              validationError.length > 0 && validationError[index].score
                ? validationError[index].score
                : ""
            }
            rowName="Score"
            onChange={(val) => {
              if (val.length < 5 || val === "") {
                this.updateScore(val, index);
              } else {
                alert("Please enter 4 numbers or characters !");
              }
            }}
          />
          <InputRow
            value={element.dateTaken}
            errMsg={
              dateTakenError ||
              (validationError.length > 0 && validationError[index].dateTaken
                ? validationError[index].dateTaken
                : "")
            }
            required={element.test !== "" ? "*" : ""}
            name="date"
            rowName={
              element.test === "18" || element.test === 18
                ? "Date To Be Taken"
                : "Date Taken"
            }
            onChange={(val) => {
              const dateTaken = new Date(val);
              if (!isNaN(dateTaken.getFullYear())) {
                if (parseInt(dateTaken.getFullYear()) <= 9999) {
                  this.updateDateTaken(val, index, dateTakenError);
                }
              } else {
                this.deleteDateTaken(val, index);
              }
            }}
          />
          {index >= 1 ? (
            <button
              type="button"
              className="save delete-icon"
              style={{ minWidth: 40, height: 40, alignSelf: "center" }}
              onClick={() => this.deleteTest(index)}
            >
              X
            </button>
          ) : null}
        </div>
      );
    });
    return (
      <div>
        <p style={{ color: "black" }}>
          In this section, kindly provide details of any official language tests
          you have completed.
          <br />
          If you have not taken one, the Admissions team will schedule a
          language placement test for you once your application has been
          submitted.
        </p>
        <p style={{ color: "black" }}>
          Click next to navigate to the next section
        </p>
        {/* {validationError.length > 0 ? (
          <p style={{ color: "black" }}>
            You must fill all available English Proficiency Types
          </p>
        ) : (
          <p> </p>
        )} */}
        {/* <p>Please enter your score and upload your certificate. If you did not reserve an English exam, please visit this website <a href={`${process.env.REACT_APP_API_ENGLISH}`} target="_blank">http://google.com</a></p> */}
        {/* <p style={{ color: "black" }}>
          Please provide your English proficiency test score, if you have not
          taken one, please select the ESLSCA English exam and indicate the date
          you would like to schedule the test.
        </p> */}
        {/* <p style={{ color: "black" }}>
          In this section, kindly provide details of any official language tests
          you have completed.
        </p>
        <p style={{ color: "black" }}>
          If you have not taken one, the Admissions team will schedule a
          language placement test for you once your application has been
          submitted.
        </p> */}
        {/* <p style={{ color: "black" }}>
          If you have taken your IELTS /TOEFL (IBT) exam and your results are
          not out yet, please do not enter data in this section.
        </p> */}
        <div className="test-view-wrapper">{testView}</div>

        <div>
          <button
            type="button"
            className="save bordered-btn"
            onClick={this.addTest}
            disabled={tests.length >= 8}
          >
            Add More
          </button>
        </div>
        <div>
          <button
            className="save"
            onClick={() => {
              this.props.onSave();
            }}
          >
            Next
          </button>
        </div>
      </div>
    );
  }
}

TestScores.propTypes = {
  collectState: PropTypes.func,
  testScore: PropTypes.array,
  error: PropTypes.array,
  onSave: PropTypes.func,
};
